import { borderRadius, display, height, lineHeight, minWidth, styled, width } from "@mui/system";
import ImageIcon from "assets/setting/image.svg";
import VideoIcon from "assets/setting/video.svg";
import EditIcon from "assets/icons/greenEditIcon.svg";
import DeleteIcon from "assets/icons/dustbinIcon.svg";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useRef, useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

import EyeIcon from "assets/setting/EyeIcon.svg";
import Tooltip from "@mui/material/Tooltip";
import { useUSPDesigns } from "./API/getAllUspDesigns";
// import RemoveModal from "components/ui/RemoveModal/RemoveModal";

import { useDeleteUSPDesign } from "./API/useDeleteUspDesign";

import USPInfoModal from "./Modal/USPInfoModal";
import UspContentModal from "./Modal/UspContentModal";
import { toast } from "react-toastify";
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useSettingContext } from "context/SettingContext";
import { useGlobalContext } from "context/GlobalContext";
import { fetchDesignData } from "./API/addBtnApi";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { getIcon } from "utils/iconsConfig";
import AddDesignModal from "./Modal/AddDesignModal";
import { formatDateWithSuffix } from "utils/formatDate";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
// USP Cell Component
const UspCellContent = ({ usp, onEyeClick }) => {
  const spanRef = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);
  useEffect(() => {
    if (spanRef.current) {
      setIsOverflow(spanRef.current.scrollWidth > 598);
    }
  }, [usp]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        padding: "0 10px",
        justifyContent: "center",
      }}
    >
      <span
        ref={spanRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          verticalAlign: "middle",
        }}
      >
        {usp}
      </span>
      {isOverflow && (
        <Tooltip title="View full USP">
          <img
            src={EyeIcon}
            alt="View"
            style={{
              width: 18,
              height: 18,
              marginLeft: 8,
              cursor: "pointer",
              verticalAlign: "middle",
            }}
            onClick={onEyeClick}
          />
        </Tooltip>
      )}
    </div>
  );
};

// ------- NEW ------------------\\

const StyledTableContainer = styled(TableContainer)(({ }) => ({
  backgroundColor: "transparent",
  maxHeight: "71vh",

  overflowX: "auto",
  background: "#000",
  position: "relative",
  border: "1px solid #fff",
  scrollbarWidth: "none", // Firefox
  "&::-webkit-scrollbar": {
    height: "6px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "3px",
  },

  "@media (max-width: 768px)": {
    maxWidth: "100%",
    overflowX: "scroll",
  },
}));

const StyledTable = styled(Table)(({ }) => ({
  "& thead": {
    backgroundColor: "#444444",
    position: "sticky",
    top: 0,
    zIndex: 1,
    "& th": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      padding: "10px",
      borderBottom: "1px solid #fff",
    },
  },
  "& tbody": {
    "& td": {
      fontSize: "18px",
      fontWeight: 400,
      lineHeight: "22px",
      color: "#FFFFFF",
      textAlign: "center",
      fontFamily: "Poppins",
      borderBottom: "1px solid #fff",
      padding: "10px 5px",
      border: "1px solid #fff",
    },
  },
  "& th": {
    backgroundColor: "#444444",
    height: "50px",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
}));

const StyledTableHeaderCell = styled(TableCell)(({ }) => ({
  fontFamily: "Poppins !important",
  position: "sticky",
  top: 0,
  padding: "10px",

  border: "none",
  zIndex: 1,
}));

const StyledTableBodyCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isUsp" && prop !== "color" && prop !== "type",
})(({ color, isUsp, type, width }) => ({
  fontFamily: "Karla !important",
  padding: "10px",
  paddingLeft: "5px",
  paddingRight: "5px",

  color: `${color} !important`,
  width: width ? width : "100%",
  "&:first-child": {},
  "&:last-child": {},
  color: type === "modifiedData" ? "#7EAAF0 !important" : "#FFFFFF",
  textDecoration: type === "modifiedData" ? "underline" : "none",
  cursor: type === "modifiedData" && "pointer",
  ...(isUsp && {
    padding: 0,
    // border: "none !important",
    width: "700px", // fixed width
    maxWidth: "700px",
    minWidth: "700px",
    margin: "0 auto", // center horizontally
    boxSizing: "border-box",
  }),
  "@media (max-width: 768px)": {
    ...(isUsp && {
      width: "100%",
      maxWidth: "700px",
      minWidth: "auto",
    }),
  },
}));

const StyledTableRow = styled(TableRow)(({ }) => ({
  "& td": {
    // padding: "10px",
    // paddingTop: "0px",
  },
  "&:first-of-type td": {
    // padding: "10px",
    // paddingTop: "15px",
  },
}));

const contentStyle = {
  width: "315px",
  height: "584px",
  backgroundColor: "#101010",
  padding: "24px 16px",
  // paddingLeft: "24px",
  borderRadius: "12px",
  border: "none !important",
  outline: "none !important",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

const modalStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalTitleStyle = {
  color: "#8B8B8B",
  fontFamily: "Poppins, sans-serif",
  fontSize: "18px",
  fontWeight: 500,
  letterSpacing: "0.41px",
  lineHeight: "22px",
};

const closeBtnStyle = {
  background: "none",
  border: "none",
  color: "#8B8B8B",
  cursor: "pointer",
  fontSize: "22px",
  padding: 0,
  lineHeight: 1,
  width: "32px",
  height: "32px",
  borderRadius: "4px",
  border: "1px solid #8B8B8B",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const videoBoxStyle = {
  // width: "270px",
  height: "480px",
  position: "relative",
  overflow: "hidden",
  minWidth: "270px",
};

const ImageContentStyle = {
  width: "1038px",
  height: "590px",
  backgroundColor: "#101010",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  border: "none !important",
  outline: "none !important",
};

const PlayPauseButton = styled("button")({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "rgba(0, 0, 0, 0.2)",
  border: "none",
  borderRadius: "50%",
  width: 56,
  height: 56,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 2,
  transition: "background 0.2s ease",
  "&:hover": {
    background: "rgba(0, 0, 0, 0.5)",
  },
});

const MuteUnmuteButton = styled("button")({
  position: "absolute",
  bottom: 16,
  right: 16,
  background: "rgba(0, 0, 0, 0.2)",
  border: "none",
  borderRadius: "50%",
  width: 40,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  zIndex: 2,
  "&:hover": {
    background: "rgba(0, 0, 0, 0.5)",
  },
  transition: "background 0.2s ease",
});

const ProductUSPAndGallery = () => {
  const location = useLocation();
  const [designNo, setDesignNo] = useState("");
  const [videoOpen, setVideoOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [progress, setProgress] = useState(0);
  const videoRef = useRef(null);
  const [imageArr, setImageArr] = useState([]);
  const [uspModalOpen, setUspModalOpen] = useState(false);
  const [uspModalContent, setUspModalContent] = useState("");
  const [data, setData] = useState([]);
  const [modifiedDateModal, setModifiedDateModal] = useState(false);
  const [USPInfoModalData, setUSPInfoModalData] = useState({});
  const queryClient = useQueryClient();
  const tableRef = useRef(null);
  const scrollPositionRef = useRef(0);
  const isDeletingRef = useRef(false);
  const [uspDetailData, setUspDetailData] = useState({});
  const [isDetail, setIsDetail] = useState(false);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [designToDelete, setDesignToDelete] = useState(null);

  const { setSearchBar, search, addModalOpen, setAddModalOpen } = useSettingContext();
  const { setSearchPlaceHolder, setFilterChangeCount, setSearchResultCount, setDisplayCount, dynamicfilterCount, setDynamicFilterCount, filterChangeCount } = useGlobalContext();

  const { mutate: deleteUSP, isPending } = useDeleteUSPDesign();

  function formatUspDate(dateString) {
    const date = new Date(dateString);

    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options).replace(/(am|pm)/i, (match) => match.toUpperCase());
  }

  useEffect(() => {
    if (videoOpen && videoRef.current) {
      videoRef.current.muted = isMuted;
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => { });
      setIsPlaying(true);
    }
    // eslint-disable-next-line
  }, [videoOpen, videoSrc]);

  const handleOpenVideo = (src, designNo) => {
    setVideoSrc(src);
    setIsMuted(true);
    setVideoOpen(true);
    setDesignNo(designNo);
  };
  const handleOpenImage = (imgArr, designNo) => {
    setImageArr(imgArr);
    setImageOpen(true);
    setDesignNo(designNo);
  };

  const handleClose = () => {
    setVideoOpen(false);
    setVideoSrc("");
    setImageOpen(false);
    setImageArr([]);
  };

  const handlePlayPause = () => {
    if (!videoRef.current) return;
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const handleMuteUnmute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  const handleTimeUpdate = () => {
    if (!videoRef.current) return;
    const percent = (videoRef.current.currentTime / videoRef.current.duration) * 100;
    setProgress(percent || 0);
  };

  const handleUspContentModel = (usp, designNo) => {
    setUspModalContent(usp);
    setUspModalOpen(true);
    setDesignNo(designNo);
  };

  const handleOpenUspInfoModal = (item) => {
    let data = {
      createdBy: `${item?.createdBy?.firstName + " " + item?.createdBy?.lastName}`,
      modifiedBy: `${item?.modifiedBy?.firstName || "--"} ${item?.modifiedBy?.lastName || "--"}`,
      createdTime: formatUspDate(item?.createdAt),
      modifiedTime: `${item?.modifiedBy?.firstName ? formatUspDate(item?.updatedAt) : "--"}`,
    };
    setUSPInfoModalData(data);
    setModifiedDateModal(true);
  };

  const handleOpenDetail = (item) => {
    setUspDetailData(item);
    setAddModalOpen(true);
    setIsDetail(true);
  };

  const permission=usePermissions();

  const hasEditAction = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Product USP and Gallery"), "edit");
  const hasDeleteAction = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Product USP and Gallery"), "delete");
  const hasMultipleMappingAction = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Product USP and Gallery"), "multiple_mapping");
 const hasActions = hasMultipleMappingAction || hasEditAction || hasDeleteAction;

  const handleEdit = (designNo) => {
    const url = `/Setting/product-usp-and-gallery/edit-uspDetails/${designNo}?isEdit=true`;
    window.open(url, "_blank");
  };

  const handleDeleteClick = (designNo) => {
    setDesignToDelete(designNo);
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = () => {
    if (!designToDelete) return;
    setDeleteConfirmOpen(false);

    if (tableRef.current) {
      scrollPositionRef.current = tableRef.current.scrollTop;
    }
    isDeletingRef.current = true;

    const payload = {
      styleNumber: designToDelete,
    };

    deleteUSP(payload, {
      onSuccess: (data) => {
        toast.success(`${data.message}`, {
          autoClose: 1000,
          hideProgressBar: false,
        });
        setDesignToDelete(null);
        refetch();
      },
      onError: (error) => {
        alert("Failed to delete USP Design");
        isDeletingRef.current = false;
        setDeleteConfirmOpen(false);
        setDesignToDelete(null);
      },
    });
  };

  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
    // setDesignToDelete(null);
  };

  // --------- API ---------------- \\

  const {
    data: fetchedDesigns,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useUSPDesigns({
    limit: 20,
    search,
  });

  useEffect(() => {
    if (isDeletingRef.current && data.length > 0 && tableRef.current) {
      setTimeout(() => {
        if (tableRef.current) {
          tableRef.current.scrollTop = scrollPositionRef.current;
        }
        isDeletingRef.current = false;
      }, 0);
    }
  }, [data]);

  useEffect(() => {
    if (fetchedDesigns?.pages?.length > 0) {
      const allData = fetchedDesigns.pages.flatMap((page) => page.data || []);
      setData(allData);
    }
  }, [fetchedDesigns]);

  // Due to window close unable to update data on this page so need this useeffect
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "refetchUSP" && event.newValue === "true") {
        localStorage.removeItem("refetchUSP");
        queryClient.invalidateQueries(["uspDesigns"]);
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    setSearchBar(true);
    setSearchPlaceHolder("Search By Design Number");

    return () => {
      setSearchBar(false);
      setSearchPlaceHolder("");
    };
  }, []);

  useEffect(() => {
    const totalDesigns = fetchedDesigns?.pages?.[0]?.totalDesigns;
    if (totalDesigns === undefined) return;

    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(totalDesigns);
      setSearchResultCount(totalDesigns);
    } else {
      setSearchResultCount(totalDesigns);
      setFilterChangeCount(filterChangeCount);
    }
    setDisplayCount(true);

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [fetchedDesigns]);

  useEffect(() => {
    if (!isDetail) {
      refetch();
    }
  }, [isDetail]);
  const scrollTimerRef = useRef(null);

  const handleScroll = () => {
    const element = tableRef.current;
    if (!element || !hasNextPage || isFetchingNextPage) return;
    const { scrollTop, scrollHeight, clientHeight } = element;
    if (scrollTop + clientHeight >= scrollHeight - 100) {
      if (scrollTimerRef.current) return;
      scrollTimerRef.current = setTimeout(() => {
        fetchNextPage();
        scrollTimerRef.current = null;
      }, 300);
    }
  };

  const TableSkeleton = ({ columnWidths = [], rows = 10 }) => (
    <>
      {Array.from(new Array(rows)).map((_, rowIndex) => (
        <StyledTableRow key={`skeleton-${rowIndex}`}>
          {columnWidths.map((width, cellIndex) => (
            <StyledTableBodyCell key={`skeleton-cell-${cellIndex}`} width={width}>
              <Skeleton
                variant="text"
                animation="wave"
                width="90%" // Slightly less than 100% for visual spacing
                height="20px"
              />
            </StyledTableBodyCell>
          ))}
        </StyledTableRow>
      ))}
    </>
  );

  return (
    <div style={{ padding: "20px", position: "relative" }}>
      <StyledTableContainer ref={tableRef} onScroll={handleScroll}>
        <StyledTable>
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell width="80px">Sr. No.</StyledTableHeaderCell>
              <StyledTableHeaderCell width="125px">Design No.</StyledTableHeaderCell>
              <StyledTableHeaderCell width="175px">Modified Date</StyledTableHeaderCell>
              <StyledTableHeaderCell>USP</StyledTableHeaderCell>
              <StyledTableHeaderCell width="122px">Image</StyledTableHeaderCell>
              <StyledTableHeaderCell width="150px">Video</StyledTableHeaderCell>
              <StyledTableHeaderCell width="150px">Actions</StyledTableHeaderCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading || isPending ? (
              <TableSkeleton columnWidths={["80px", "125px", "175px", "auto", "122px", "150px", "150px"]} rows={10} />
            ) : fetchedDesigns?.pages[0]?.data.length > 0 ? (
              fetchedDesigns?.pages?.map((page, pageIndex) =>
                page?.data?.map((item, index) => {
                  const globalIndex = fetchedDesigns.pages.slice(0, pageIndex).reduce((acc, p) => acc + p.data.length, 0) + index + 1;
                  return (
                    <StyledTableRow key={globalIndex} type={globalIndex === 1 ? "bodyFirst" : ""}>
                      <StyledTableBodyCell width="80px">{globalIndex}</StyledTableBodyCell>
                      <StyledTableBodyCell width="125px">{item.styleNumber}</StyledTableBodyCell>
                      <StyledTableBodyCell width="175px" type="modifiedData" onClick={() => handleOpenUspInfoModal(item)}>
                        {formatDateWithSuffix(item.updatedAt)}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell isUsp>
                        <UspCellContent usp={item.uspMsg} onEyeClick={() => handleUspContentModel(item.uspMsg, item.styleNumber)} />
                      </StyledTableBodyCell>
                      <StyledTableBodyCell width="122px">
                        {item?.images?.length > 0 ? (
                          <img
                            src={ImageIcon}
                            alt="Image Icon"
                            style={{ width: "55px", height: "28px", cursor: "pointer" }}
                            onClick={() => handleOpenImage(item.images, item.styleNumber)} // Example images
                          />
                        ) : (
                          "N/A"
                        )}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell width="120px">
                        {item?.videos?.length > 0 ? (
                          <img src={VideoIcon} alt="Video Icon" style={{ width: "55px", height: "28px", cursor: "pointer" }} onClick={() => handleOpenVideo(item.videos[0], item.styleNumber)} />
                        ) : (
                          "N/A"
                        )}
                      </StyledTableBodyCell>
                      <StyledTableBodyCell
                        width="auto"
                        sx={{ display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "none !important", borderLeft: "none !important", borderRight: "none !important" }}
                      >
                         {!hasActions ? (
                            "No actions "
                          ) : (
                           <>
                        {hasMultipleMappingAction && (
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            padding: "0",
                            marginRight: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOpenDetail(item)}
                        >
                          {getIcon("UspDetailIcon")}
                        </button>
                        )}

                      {hasEditAction && (
                        <button
                          style={{
                            background: "none",
                            border: "none",
                            padding: "0",
                            marginRight: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleEdit(item.styleNumber)}
                        >
                          <img src={EditIcon} alt="Edit Icon" style={{ width: "22px", height: "22px" }} />
                        </button>
                      )}

                      {hasDeleteAction && (
                        <button
                          style={{ background: "none", border: "none", padding: "0", cursor: "pointer" }}
                          onClick={() => {
                            handleDeleteClick(item.styleNumber);
                          }}
                        >
                          <img src={DeleteIcon} alt="Delete Icon" style={{ width: "22px", height: "22px" }} />
                        </button>
                      )}
                    </>
                  )}
                      </StyledTableBodyCell>
                    </StyledTableRow>
                  );
                })
              )
            ) : (
              <StyledTableRow>
                <StyledTableBodyCell colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                  No Data Available
                </StyledTableBodyCell>
              </StyledTableRow>
            )}

            {isFetchingNextPage && <TableSkeleton columnWidths={["80px", "125px", "175px", "auto", "122px", "150px", "150px"]} rows={5} />}
          </TableBody>
        </StyledTable>
      </StyledTableContainer>

      {/* Modal for Video Playback */}
      <Modal open={videoOpen} onClose={handleClose} sx={modalStyle}>
        {/* <Box sx={videoBoxStyle}> */}
        <Box sx={contentStyle}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={modalTitleStyle}>Video ({designNo})</span>
            <button style={closeBtnStyle} onClick={handleClose} aria-label="Close">
              <CloseIcon fontSize="inherit" />
            </button>
          </Box>
          <Box sx={{ ...videoBoxStyle, position: "relative", overflow: "hidden" }}>
            {videoSrc && (
              <>
                <video
                  ref={videoRef}
                  src={videoSrc}
                  muted={isMuted}
                  autoPlay
                  onClick={handlePlayPause}
                  onTimeUpdate={handleTimeUpdate}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "3px",
                    background: "#000",
                    display: "block",
                    cursor: "pointer",
                  }}
                />

                {/* Play/Pause Button */}
                <PlayPauseButton onClick={handlePlayPause}>
                  {isPlaying ? (
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="#fff">
                      <rect x="7" y="7" width="6" height="18" rx="2" />
                      <rect x="19" y="7" width="6" height="18" rx="2" />
                    </svg>
                  ) : (
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="#fff">
                      <polygon points="8,6 26,16 8,26" />
                    </svg>
                  )}
                </PlayPauseButton>
                {/* Mute/Unmute Button */}
                <MuteUnmuteButton onClick={handleMuteUnmute}>
                  {isMuted ? (
                    <svg width="24" height="24" fill="#fff" viewBox="0 0 24 24">
                      <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63m2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71M4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9zM12 4 9.91 6.09 12 8.18z"></path>
                    </svg>
                  ) : (
                    <svg width="24" height="24" fill="#fff" viewBox="0 0 24 24">
                      <path d="M16.5 12c0-1.77-.77-3.29-2-4.29v8.58c1.23-1 2-2.52 2-4.29zm3.5 0c0 2.53-1.17 4.77-3 6.18v-2.06c1.16-.84 2-2.18 2-3.74s-.84-2.9-2-3.74V5.82c1.83 1.41 3 3.65 3 6.18zM4 9v6h4l5 5V4L8 9H4z" />
                    </svg>
                  )}
                </MuteUnmuteButton>
                {/* Progress Bar */}

                <div
                  onClick={(e) => {
                    const rect = e.currentTarget.getBoundingClientRect();
                    const clickX = e.clientX - rect.left;
                    const clickPercentage = clickX / rect.width;

                    const video = videoRef.current;
                    if (video && video.duration) {
                      video.currentTime = clickPercentage * video.duration;
                    }
                  }}
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    height: 4,
                    width: "100%",
                    background: "rgba(255,255,255,0.2)",
                    borderRadius: "0 0 12px 12px",
                    overflow: "hidden",
                    cursor: "pointer",
                  }}
                >
                  <div
                    style={{
                      height: "100%",
                      width: `${progress}%`,
                      background: "#fff",
                      transition: "width 0.2s linear",
                    }}
                  />
                </div>
              </>
            )}
          </Box>
        </Box>
      </Modal>
      {/* Modal for Image Preview */}
      <Modal open={imageOpen} onClose={handleClose} sx={modalStyle}>
        <Box sx={ImageContentStyle}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "32px", marginTop: "16px", marginRight: "16px", marginLeft: "32px" }}>
            <span style={modalTitleStyle}>Image ({designNo})</span>
            <button style={closeBtnStyle} onClick={handleClose} aria-label="Close">
              <CloseIcon fontSize="inherit" />
            </button>
          </Box>
          <Box sx={{ marginLeft: "32px", marginRight: "34px", marginBottom: "32px", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px" }}>
            {imageArr.map((img, index) => (
              <img key={index} src={img} alt={`Image ${index + 1}`} width={"225px"} height={"225px"} style={{ borderRadius: "5px" }} />
            ))}
          </Box>
        </Box>
      </Modal>

      {/* Modal for Usp Content */}
      <UspContentModal uspModalOpen={uspModalOpen} setUspModalOpen={setUspModalOpen} uspModalContent={uspModalContent} designNo={designNo} />
      {/* Modal for Modified Datae */}
      <USPInfoModal modifiedDateModal={modifiedDateModal} setModifiedDateModal={setModifiedDateModal} Data={USPInfoModalData} />

      <AddDesignModal open={addModalOpen} onClose={() => setAddModalOpen(false)} uspDetailData={uspDetailData} isDetail={isDetail} setIsDetail={setIsDetail} existingData={data} />
      <RemoveModal
        open={deleteConfirmOpen}
        setOpen={setDeleteConfirmOpen}
        heading={
          <>
            Are you sure you want to delete{" "}
            <span style={{ fontWeight: 600 }}>{designToDelete}</span> Design?
          </>
        }
        cumWidth="505px"
        btnInfo={[
          {
            btnName: "No",
            bgColor: "rgba(231, 123, 123, 1)",
            color: "#000000",
            click: cancelDelete
          },
          {
            btnName: "Yes",
            bgColor: "rgba(80, 200, 120, 1)",
            color: "#000000",
            click: confirmDelete,
            // disabled: isPending
          }
        ]}
      />
    </div>
  );
};

export default ProductUSPAndGallery;
